import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logo.svg'
import _imports_1 from '@/assets/img/icons/clear.svg'
import _imports_2 from '@/assets/img/icons/next.svg'


const _hoisted_1 = { class: "flex gap-16" }
const _hoisted_2 = { class: "w-1/3 flex-shrink-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-1/3 mb-3"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl text-blue-900 mb-3 font-semibold" }, "Tambah Peserta", -1)
const _hoisted_5 = { class: "text-lg mb-2 font-semibold" }
const _hoisted_6 = { class: "text-gray-400 text-sm mb-3" }
const _hoisted_7 = { class: "mb-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs leading-5 text-gray-500 mb-2" }, " Pisahkan peserta dengan menggunakan spasi “ ” ", -1)
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "relative h-16" }
const _hoisted_13 = { class: "bg-white border-t p-2 left-0 flex gap-3 justify-end fixed bottom-0 w-full" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_label = _resolveComponent("input-label")!
  const _component_assessment_list = _resolveComponent("assessment-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.projectDetail.name), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.projectDetail.started_at) + " - " + _toDisplayString(_ctx.projectDetail.ended_at), 1),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_input_label, {
              label: "Email Peserta",
              isRequired: true
            }),
            _hoisted_8,
            _createElementVNode("div", {
              class: "border-1 border-gray-400 rounded p-3",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.focusOnEmailInput && _ctx.focusOnEmailInput(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emails, (email, emailIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: emailIdx,
                  class: "mr-2 mb-1 inline-block bg-gray-100 text-sm leading-4 rounded-sm px-2 py-1"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(email) + " ", 1),
                    _createElementVNode("img", {
                      onClick: ($event: any) => (_ctx.removeEmail(emailIdx)),
                      src: _imports_1,
                      class: "cursor-pointer"
                    }, null, 8, _hoisted_10)
                  ])
                ]))
              }), 128)),
              _withDirectives(_createElementVNode("input", {
                ref: "emailInputRef",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailInput) = $event)),
                onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.insertEmail && _ctx.insertEmail(...args)), ["space"])),
                onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.removeEmailOnDelete && _ctx.removeEmailOnDelete(...args)), ["delete"])),
                onPaste: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pasteEmail && _ctx.pasteEmail(...args))),
                onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.insertEmail && _ctx.insertEmail(...args))),
                type: "text",
                class: _normalizeClass(["border-none outline-none rounded bg-transparent", !_ctx.emails.length && 'w-full']),
                placeholder: 
                _ctx.emails.length
                  ? ''
                  : 'Masukkan semua email peserta yang ingin anda undang'
              
              }, null, 42, _hoisted_11), [
                [_vModelText, _ctx.emailInput]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_input_label, {
              label: "Batas Akhir Pengerjaan Tes",
              isRequired: true
            }),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.endedAt) = $event)),
              class: "p-2 border rounded w-full"
            }, null, 512), [
              [_vModelText, _ctx.endedAt]
            ])
          ])
        ])
      ]),
      _createVNode(_component_assessment_list, {
        data: _ctx.assessments,
        selectedAssessment: _ctx.selectedAssessment,
        onSetSelectedAssessment: _ctx.setSelectedAssessment
      }, null, 8, ["data", "selectedAssessment", "onSetSelectedAssessment"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "px-4 py-2 bg-transparent border-1 border-gray-300 rounded text-blue-900 text-sm leading-6 font-semibold flex items-center gap-3"
        }, " Batal "),
        _createElementVNode("button", {
          disabled: !_ctx.canSubmit,
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.payInvitation && _ctx.payInvitation(...args))),
          class: _normalizeClass(["px-4 py-2 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3", 
          _ctx.canSubmit ? 'bg-yellow-400 opacity-1' : 'bg-gray-400 opacity-30'
        ])
        }, [
          _createTextVNode(" Lanjutkan "),
          _hoisted_15
        ], 10, _hoisted_14)
      ])
    ])
  ], 64))
}